import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HierarchyNavigationHeatmapChartView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  template_path: JST['backbone/templates/monitoring/charts/tree_path']
  hierarchySelectingTemplate: JST["backbone/templates/monitoring/hierarchy_select"]
  className: 'processing item w2 bars-chart'

  events:
    'click .subpath': 'onSubpath'
    'mouseover .subpath': 'onMouseOver'
    'mouseout .subpath': 'onMouseOut'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'
    'click .taxonomyChoise': 'changeTaxonomy',
    'click #change_hierarchy': 'onClickChangeHierarchy'

  initialize: (@options = {}) =>
    @path = @options.settings.path || []
    @inClickWindowTime = false
    @searchQuery = @options.searchQuery
    @_settings = @options.settings
    @_settings.maximized = !!@_settings.maximized
    @_settings.currentTaxonomyCode = @_settings.currentTaxonomyCode || 'Default'
    @title = @_settings.title
    @title_en = @_settings.title
    @container = @options.container
    @tags_limit = 10
    @_settings['reduced_tree'] = true
    @taxonomiesRepository = new Monitoring.Models.TaxonomiesRepository
    @hierarchyNavigators = {}
    @data = {}

  render: ->
    @$el.html(@template({
      title: @title
    }))
    if @_settings.maximized then @$el.toggleClass('h2')
    return this

  fillData: ->
    _.each @hierarchyNavigators, (hierarchyNavigator, dimensionKey) =>
      @data[dimensionKey] = hierarchyNavigator.extractData()

  afterAppend: ->
    if !_.isEmpty(@hierarchyNavigators)
      @fillData()
      @_settings.path = @path
      @trigger('chartsChange')
      @afterAppendHTML()
    else
      @taxonomiesRepository.loadAlternativeTaxonomies(() =>
        @$el.find('#close_chart').before(@hierarchySelectingTemplate(
          includeAlternativeTaxonomies: Keepcon.currentAccount.includeAlternativeTaxonomies,
          taxonomiesRepository: @taxonomiesRepository
        ))
        query = @searchQuery.toJSON()
        query.taxonomy_code = @_settings.hierarchyCode
        query.dimension = @_settings.dimension
        @ajaxCall('/monitoring/dashboard/charts/hierarchy_heatmap', query, (response) =>
          _.each response, (value, dimensionKey) =>
            options = { ordered: true }
            @hierarchyNavigators[dimensionKey] = new Monitoring.Views.Charts.HierarchyNavigator(@path, value, options)
          @fillData()
          @afterAppendHTML()
        )
      )
    return this

  afterAppendHTML: ->
    @$el.find('.chart').html('')
    if @_dataIsEmpty()
      @$el.find('.chart').addClass('no-data')
    else
      @$el.find('.chart').removeClass('no-data')
      setTimeout => # to avoid the harmless "Uncaught TypeError: a.onContainerClick is not a function"
        @chart = new Highcharts.Chart(@_getOptions())
        @trigger('masonry')
      , 20
    $(this.el).find("#path").html(@template_path(tree_path: @_path()))
    @$el.removeClass('processing')

  firstHierarchyNavigator: ->
    @hierarchyNavigators[Object.keys(@hierarchyNavigators)[0]]

  _path: ->
    if _.isEmpty(@hierarchyNavigators) then @path else @firstHierarchyNavigator().path

  _dataIsEmpty: ->
    _.every @hierarchyNavigators, (hierarchyNavigator, dimensionKey) ->
      hierarchyNavigator.dataIsEmpty()

  removeEmptyData: =>
    _.each @data, (dimensionItem, key) =>
      if @allZeroValues(dimensionItem)
        delete @data[key]

  allZeroValues: (dimensionItem) =>
    allZeros = true
    _.each dimensionItem, (tag) =>
      allZeros = allZeros && tag["y"] == 0
    return allZeros

  filterFilledMatrix: =>
    totalColumns = @matrix.length
    currentColumnIndex = 0
    while currentColumnIndex < totalColumns
      if @emptyColumn(currentColumnIndex)
        name = @matrix[currentColumnIndex][0]["name"]
        @matrix.splice(currentColumnIndex, 1)
        @xAxisCategories.splice(@xAxisCategories.indexOf(name),1)
        totalColumns -= 1
        currentColumnIndex -= 1
      currentColumnIndex += 1

  emptyColumn: (columnIndex) =>
    totalRows = @matrix[0].length
    currentRowIndex = 0
    allZeros = true
    while currentRowIndex < totalRows
      allZeros = allZeros && @matrix[columnIndex][currentRowIndex]["y"] == 0
      return false if !allZeros
      currentRowIndex += 1
    return true

  _generateMatrix: ->
    @removeEmptyData()
    # x axis
    names = []
    _.each @data, (tags, dimensionKey) =>
      _.each tags, (tag) =>
        names.push tag.name
    @xAxisCategories = _.uniq(names)
    # y axis
    @yAxisCategories = Object.keys(@data)
    # empty matrix
    @matrix = []
    _.each @xAxisCategories, (xCategoryName, xIndex) =>
      @matrix[xIndex] = []
      _.each @yAxisCategories, (yCategoryName, yIndex) =>
        @matrix[xIndex][yIndex] = null
    # fill matrix
    _.each @data, (tags, dimensionKey) =>
      yIndex = _.indexOf(@yAxisCategories, dimensionKey)
      _.each tags, (tag) =>
        name = tag.name
        xIndex = _.indexOf(@xAxisCategories, name)
        @matrix[xIndex][yIndex] = tag
    # filter matrix
    @filterFilledMatrix()
    # generate highcharts data
    highcharts_data = []
    _.each @xAxisCategories, (xCategoryName, xIndex) =>
      _.each @yAxisCategories, (yCategoryName, yIndex) =>
        tag = @matrix[xIndex][yIndex]
        value = if tag then tag.y else 0
        highcharts_data.push([xIndex, yIndex, value])

    events =
      click: @deepInto
      mouseOver: @cellMouseIn
      mouseOut: @cellMouseOut

    @highcharts_data = [{ borderWidth: 0, data: highcharts_data, dataLabels: { enabled: true, color: '#000000' }, point: { events: events }, turboThreshold: Number.MAX_VALUE  }]

  deepInto: (event) =>
    xIndex = event.point.x
    yIndex = event.point.y
    tag = @matrix[xIndex][yIndex]
    tag_name = tag.name
    target_name = tag_name.trim()
    results = _.map @hierarchyNavigators, (hierarchyNavigator, dimensionKey) => hierarchyNavigator.deepInto(target_name)
    flag = _.some results, (element) -> element
    @afterAppend() if flag

  onSubpath: (event) =>
    text = @htmlDecode(event.target.innerHTML.trim())
    results = _.map @hierarchyNavigators, (hierarchyNavigator, dimensionKey) => hierarchyNavigator.onSubpath(text)
    flag = _.some results, (element) -> element
    @afterAppend() if flag

  dispatchEvent: (event) =>
    if @inClickWindowTime
      clearTimeout(@delayed_timeout) if @delayed_timeout
      @deepInto(event)
      @inClickWindowTime = false
    else
      @delayed_timeout = setTimeout((=>@_chartClick event), 400)
      @inClickWindowTime = true

  _chartClick:(event) =>
    @inClickWindowTime = false
    # @createPreviewDashboard(@getNewQuery(event))
    false

  getNewQuery: (event) ->
    xIndex = event.point.x
    yIndex = event.point.y
    node = @matrix[xIndex][yIndex]
    return @searchQuery unless node
    tags = _.uniq(@_join_tags(node))
    query = @searchQuery.deepCopy()
    if _.isEmpty(query.get('primary_tags'))
      key = 'primary_tags'
    else if query.get('primary_tags')[0] == 'allTags'
      key = 'primary_tags'
    else
      key = 'secondary_tags'
    query.set(key, tags)
    return query

  _join_tags: (node) ->
    tags = []
    if node.tags
      tags = tags.concat node.tags
    if node.children
      for i in [0...node.children.length]
        tags = tags.concat @_join_tags node.children[i]
    tags

  onMouseOver: (event) =>
    $(event.target).addClass("link-path")

  onMouseOut: (event) =>
    $(event.target).removeClass("link-path")

  toggleMaximize: =>
    @_settings.maximized = !@_settings.maximized
    @$el.toggleClass('h2')
    @trigger('chartsChange')
    @afterAppend()

  toggleReducedTree: =>
    _.each @hierarchyNavigators, (hierarchyNavigator, dimensionKey) => hierarchyNavigator.toggleReducedTree()
    @_settings.reduced_tree = !@_settings.reduced_tree
    @trigger('chartsChange')
    @afterAppend()

  htmlDecode: (input) ->
    e = document.createElement('div')
    e.innerHTML = input
    e.childNodes[0].nodeValue

  cellMouseIn: (event) =>
    @_destroySelectionHighlight()
    xIndex = event.target.x
    yIndex = @chart.yAxis[0].categories.length
    x0 = @chart.xAxis[0].toPixels(xIndex)
    x1 = @chart.xAxis[0].toPixels(xIndex + 1)
    width = x1 - x0
    y0 = @chart.yAxis[0].toPixels(yIndex)
    y1 = @chart.yAxis[0].toPixels(0)
    height = y1 - y0
    x0 = x0 - (width / 2)
    y0 = y0 + ((height / 2) / yIndex)
    attributes = { 'stroke-width': 3, stroke: 'rgb(226,144,23)', zIndex: 3 }
    @selectionHighlight = @chart.renderer.rect(x0, y0, width, height).attr(attributes).add()

  cellMouseOut: (event) =>
    @_destroySelectionHighlight()

  _destroySelectionHighlight: ->
    return unless @selectionHighlight
    @selectionHighlight.destroy()
    @selectionHighlight = undefined

  _getOptions: ->
    @_generateMatrix()
    totalRows = @matrix[0].length
    offset = Math.trunc(totalRows / 12) + 1
    @$el.attr('data-height', offset)
    xCategoriesNamesLengths = @xAxisCategories.map (element) -> element.length
    longestCategoryNameLength = _.max(xCategoriesNamesLengths)
    totalXAxisLabelsWidth = 0.85 * @$el.find('.chart')[0].offsetWidth
    eachCategoryMaxPossibleWitdh = totalXAxisLabelsWidth / @xAxisCategories.length
    eachCategoryMaxPossibleLength =  eachCategoryMaxPossibleWitdh / 8
    if longestCategoryNameLength > eachCategoryMaxPossibleLength
      marginBottom = Math.max(70, 5 * longestCategoryNameLength)
    else
      marginBottom = 70
    options = {
      chart:
        renderTo: @$el.find('.chart')[0]
        type: 'heatmap'
        marginBottom: marginBottom
        marginTop: 35
        height: 300 * offset
      title:
        text: null
      legend:
        align: 'right'
        verticalAlign: 'top'
        x: 0
        y: 40
        floating: false
        layout: "vertical"
      xAxis:
        categories: @xAxisCategories
        title: null
      yAxis:
        categories: @yAxisCategories
        title: null
        labels:
          step: 1
      colorAxis:
        min: 0
        minColor: '#FFFFFF'
        maxColor: '#FF9800'
      tooltip:
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        formatter: @_tooltipFormatter
      plotOptions:
        heatmap:
          cursor: 'pointer'
          states:
            hover:
              enabled: false
          dataLabels:
            style:
              color: '#35444C'
              fontWeight: 'normal'
      isHierarchical: true
      isBarHierarchyNavigation: true
      series: @highcharts_data
      isHeatmap: true
    }
    # options['exporting'] = @_getExportingOptions()
    # options.exporting.buttons.contextButton.menuItems = @_menuOptions()
    return options

  _tooltipFormatter: () ->
    if @key
      "<b>#{@point.original_name}</b><br/>Cantidad: #{@point.y} (#{Math.round(@percentage * 10) / 10}%)"
    else
      false

  _menuOptions: =>
    menuItems = Highcharts.getOptions().exporting.buttons.contextButton.menuItems
    menuItems = menuItems.concat({separator:true})
    unless window.sharedSession
      menuItems = menuItems.concat({
        text: if @_settings.maximized then I18n.t('monitoring.dashboard.charts.export_options.normal') else I18n.t('monitoring.dashboard.charts.export_options.maximize')
        onclick: (() => @toggleMaximize())
      })
    menuItems = menuItems.concat({
      text: if @_settings.reduced_tree then I18n.t('monitoring.dashboard.charts.display_all_tags') else I18n.t('monitoring.dashboard.charts.reduce_tags')
      onclick: (() => @toggleReducedTree())
    })
    menuItems = menuItems.concat(@exportingOptions)

  _getExportingOptions: ->
    return buttons:
      contextButton:
        menuItems: []
        x: -12

  onClickChangeHierarchy: (evt) ->
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')

  changeTaxonomy: (evt) ->
    chosenTaxonomyName = $(evt.target).text()
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')
    taxonomy = @taxonomiesRepository.taxonomyWithName(chosenTaxonomyName)
    @_settings.currentTaxonomyCode = taxonomy.get('code')
    query = @searchQuery.deepCopy()
    query.set('taxonomy_code', @_settings.currentTaxonomyCode)
    query.set('dimension', @_settings.dimension)
    @ajaxCall('/monitoring/dashboard/charts/hierarchy_heatmap', query.toJSON(), (response) =>
      _.each response, (value, dimensionKey) =>
        options = { ordered: true }
        @hierarchyNavigators[dimensionKey] = new Monitoring.Views.Charts.HierarchyNavigator(@path, value, options)
        @hierarchyNavigators[dimensionKey].onSubpath('')
      @path = @options.settings.path || []
      @afterAppend()
    )
